module.exports = __webpack_public_path__ + "static/media/recolher.a2c21cab.svg";